import React from "react";
import {
  Table,
  Checkbox,
  Button,
  Menu,
  Icon,
  Dropdown,
  Input,
  Select,
  Tooltip
} from "antd";
import prettysize from "../../../utils";

import "./styles.scss";

export default class ResultView extends React.Component {
  constructor(props) {
    super(props);
    this.columns = [
      {
        title: "File Name",
        dataIndex: "name",
        key: "filename"
      },
      {
        title: "Last Modified",
        dataIndex: "last_modified",
        key: "lastModified",
        render: d => formatDate(new Date(d))
      },
      {
        title: "Size",
        dataIndex: "size",
        key: "size",
        render: s => prettysize(s)
      },
      {
        title: "",
        dataIndex: "selected",
        key: "selected",
        render: selected => <Checkbox checked={selected} />
      }
    ];
  }

  render() {
    const { loading, results, on_file_select, view, viewCount } = this.props;
    return (
      <div className="result-view">
        {view === "table" ? (
          results.length > 0 ? (
            <Table
              rowKey={file => `${file.cloud_account_id}_${file.full_path}`}
              columns={this.columns}
              dataSource={results}
              onRow={file => ({
                onClick: e => on_file_select(file, e.target.type !== "checkbox")
              })}
              pagination={{ hideOnSinglePage: true, pageSize: viewCount }}
            />
          ) : (
            <div className="view-empty">
              <h1 className="no-files">No Files To Display</h1>
            </div>
          )
        ) : (
          <ListView
            files={results}
            onFileSelect={on_file_select}
            colItemsCount={20}
          />
        )}
      </div>
    );
  }
}

const partition = (items, partition) => {
  let results = [];
  for (let i = 0; i < items.length; i += partition) {
    results.push(items.slice(i, i + partition));
  }
  return results;
};

const ListViewItem = ({ file, onFileSelect, hidden }) => (
  <div
    className="item"
    style={{ visibility: hidden ? "hidden" : "visible" }}
    onClick={e => onFileSelect(file, true)}
  >
    <div className="item-name">{file.name}</div>
    <div className="item-checkbox">
      <Checkbox
        onClick={e => e.stopPropagation()}
        onChange={() => onFileSelect(file)}
        checked={file.selected}
      />
    </div>
  </div>
);

const ListViewColumn = ({ files, onFileSelect, colItemsCount }) => {
  let fillers = [];
  for (let i = 0; i < colItemsCount - files.length; i++) {
    fillers.push(
      <ListViewItem hidden={true} file={{ name: "" }} onFileSelect={() => {}} />
    );
  }
  return (
    <div className="column">
      {files.map(file => (
        <ListViewItem file={file} onFileSelect={onFileSelect} />
      ))}
      {fillers}
    </div>
  );
};

const ListView = ({ files, colItemsCount = 10, onFileSelect }) => {
  if (files.length === 0) {
    return (
      <div className="view-empty">
        <h1 className="no-files">No Files To Display</h1>
      </div>
    );
  }
  const partFiles = partition(files, colItemsCount);
  return (
    <div className="list-view">
      {partFiles.map(colFiles => (
        <ListViewColumn
          files={colFiles}
          onFileSelect={onFileSelect}
          colItemsCount={colItemsCount}
        />
      ))}
    </div>
  );
};

const formatDate = d => {
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "June",
    "July",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec"
  ];
  const hours = d.getHours() > 12 ? d.getHours() - 12 : d.getHours();
  const suffix = d.getHours() > 12 ? "pm" : "am";

  return `${
    months[d.getMonth()]
  } ${d.getDate()},${d.getFullYear()}, ${hours}:${d.getMinutes()}${suffix}`;
};
